import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { SiteService } from 'src/app/services/site.service';

@Component({
	selector: 'app-app-download-overlay',
	templateUrl: './app-download-overlay.component.html',
	styleUrls: ['./app-download-overlay.component.scss']
})
export class AppDownloadOverlayComponent implements OnInit, OnChanges {
	@Input() data: any = {};
	@Input() employerPath: string = '';
	@Input() eapUrl: string = '';
	@Input() eapPhone: string = '';
	@Input() ctaType: string = '';
	@Input() groupCode: string = '';
	@Input() groupCodeLabel: string = '';
	@Output() dismissed = new EventEmitter<void>();

	public visible: boolean = false;
	public registerText: string = 'Register';
	public headlineText: string = 'Register and have support anywhere';
	public bodyText: string = 'Download the app to access your EAP resources \u2013 always available when you or your family needs it.';
	public scanText: string = 'Scan to download';

	private get storageKey(): string {
		return 'om-app-overlay-seen-' + this.employerPath;
	}

	constructor(
		private translationService: TranslationService,
		private siteService: SiteService
	) {}

	ngOnInit(): void {
		// TODO: Uncomment this block to restore "show only once" behavior
		// if (localStorage.getItem(this.storageKey)) {
		// 	this.dismissed.emit();
		// } else {
		// 	this.visible = true;
		// }
		this.visible = true; // TODO: Remove this line when restoring "show only once" behavior
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['data']) {
			this.updateTexts();
		}
	}

	sanitizePhone(phone: string): string {
		if (!phone) return '';
		return phone.replace(/\D/g, '');
	}

	private updateTexts(): void {
		this.registerText = this.ctaType === 'Call EAP' ? 'Call to Register' : 'Register';

		const currentLang = this.translationService.getCurrentLanguage();
		if (currentLang === 'en') return;

		const employer = this.siteService.onEmployerSet.getValue();
		if (!employer) return;

		const items = [
			{ id: 'app-overlay-register', text: this.registerText },
			{ id: 'app-overlay-headline', text: this.headlineText },
			{ id: 'app-overlay-body', text: this.bodyText },
			{ id: 'app-overlay-scan', text: 'Scan to download' }
		];

		this.translationService.translatePage(employer.employerID, '/home', items).subscribe(translations => {
			this.registerText = translations['app-overlay-register'] || this.registerText;
			this.headlineText = translations['app-overlay-headline'] || this.headlineText;
			this.bodyText = translations['app-overlay-body'] || this.bodyText;
			this.scanText = translations['app-overlay-scan'] || this.scanText;
		});
	}

	dismiss(): void {
		this.visible = false;
		// TODO: Uncomment this line to restore "show only once" behavior
		// localStorage.setItem(this.storageKey, 'true');
		this.dismissed.emit();
	}
}
